import { render, staticRenderFns } from "./WorkoutStepEditable.vue?vue&type=template&id=f38b67a2&scoped=true&xmlns=true"
import script from "./WorkoutStepEditable.vue?vue&type=script&lang=js"
export * from "./WorkoutStepEditable.vue?vue&type=script&lang=js"
import style0 from "./WorkoutStepEditable.vue?vue&type=style&index=0&id=f38b67a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38b67a2",
  null
  
)

export default component.exports